export function getSeekQuestionnaire(applicationId) {
    return axios.get(route('api.manage.applications.seekQuestionnaire', { applicationId }))
        .then(response => response.data);
}
